import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PortsListTable from './Table';
import { getPorts } from 'actions/regions/ports';

const PortsPage = ({
    page, query, onlyChanged, sort, getPorts,
}) => {
    useEffect(() => {
        getPorts({
            page, query, onlyChanged, sort, 
        });
    }, [page, query, onlyChanged, sort, getPorts]);

    return (
        <div id='ports' className='table-page'>
            <div className='container'>
                <h2>
                    Ports
                </h2>
                <PortsListTable />
            </div>
        </div>
    );
};

PortsPage.propTypes = {
    isLogged: PropTypes.bool,
    getPorts: PropTypes.func,
    page: PropTypes.number,
    query: PropTypes.string,
    onlyChanged: PropTypes.bool,
    sort: PropTypes.string,
};

PortsPage.defaultProps = {
    isLogged: false,
    getPorts: () => {
        console.error('PortsPage didn\'t find getPorts function');
    },
    page: 1,
    query: '',
    onlyChanged: false,
    sort: '',
};

export default connect(
    ({
        user: { isLogged }, ports: {
            page, query, onlyChanged, sort, 
        }, 
    }) => ({
        isLogged,
        page,
        query,
        onlyChanged,
        sort,
    }),
    dispatch => bindActionCreators(
        {
            getPorts,
        },
        dispatch,
    ),
)(PortsPage);



// WEBPACK FOOTER //
// ./app/components/Regions/Ports/Page.jsx